module.exports = __webpack_public_path__ + "img/stage_malve.5b0112f2.jpg";